import { Box } from '@chakra-ui/react';
import { AdminLayout } from '@diamond/sol-admin/components';

export function BannerLoadError() {
  return (
    <AdminLayout>
      <Box py={4}>Gagal memuat data banner. Silakan refresh halaman.</Box>
    </AdminLayout>
  );
}
